import {Owner} from "./owner";
import {Card} from "./card";

export class Source {

  constructor (
  public id             :string,
  public object         :string,
  public amount         :string,
  public client_secret  :string,
  public created        :string,
  public currency       :string,
  public flow           :string,
  public livemode       :boolean,
  public owner          :Owner,
  public statement_descriptor :string,
  public status               :string,
  public type                 :string,
  public usage                :string,
  public card                 :Card,


  ){};

  static fromJsonList(array):Source[]{
    return array.map(json => Source.fromJson(json));
  }

  static fromJson({
                    id,
                    object,
                    amount,
                    client_secret,
                    created,
                    currency,
                    flow,
                    livemode,
                    owner,
                    statement_descriptor,
                    status,
                    type,
                    usage,
                    card
                  }) : Source {
  return new Source (
    id,
    object,
    amount,
    client_secret,
    created,
    currency,
    flow,
    livemode,
    owner,
    statement_descriptor,
    status,
    type,
    usage,
    card
  )
}

}



// WEBPACK FOOTER //
// ./src/app/shared/model/source.ts